export const KEY_CODES = {
    ENTER: "Enter"
};
export const DISABLED_CLASS = "ch-disabled";
// - - - - - - - - - - - - - - - - - - - -
//               Line clamp
// - - - - - - - - - - - - - - - - - - - -
export const HEIGHT_MEASURING = "height-measuring";
export const LINE_CLAMP = "line-clamp";
export const LINE_MEASURING = "line-measuring";
//# sourceMappingURL=reserverd-names.js.map
